import { render } from "./LessonSummary.vue?vue&type=template&id=1b4edaaf"
import script from "./LessonSummary.vue?vue&type=script&lang=js"
export * from "./LessonSummary.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__